import React, { useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@ygtechnologies/bygr-frontend-component-library';
import { triggerHandler } from '@ygtechnologies/rubus-frontend-utilities';
import { getDocumentLinkedResidentialUnits, setDocumentLinkedResidentialUnits } from '@/services/documents';
import { Button } from '@/components/Buttons';
import { IState } from '@/state/IState';
import { useSelector } from 'react-redux';
import { UnitSelector } from '../UnitSelector';

interface OwnProps {
    documentVersionId: number;
    onClose(): void;
    onAccept(): void;
    show: boolean;
}

const DocumentLinkDialog: React.FC<OwnProps> = ({ documentVersionId, onClose, onAccept, show }) => {
    const [saving, setSaving] = useState(false);
    const [linkedResidentialUnitIds, setLinkedResidentialUnitIds] = useState<number[]>([]);
    const projectId = useSelector((state: IState) => state.global.activeProject!.id);

    const handleOpen = async () => {
        setSaving(false);
        setLinkedResidentialUnitIds([]);
        var links = await getDocumentLinkedResidentialUnits(documentVersionId);
        setLinkedResidentialUnitIds(links.map((x) => x.residentialUnitId));
    };

    const handleCancelClick = () => {
        triggerHandler(onClose);
    };

    const handleAccept = async (e) => {
        setSaving(true);

        try {
            await setDocumentLinkedResidentialUnits(documentVersionId, linkedResidentialUnitIds);

            triggerHandler(onAccept);
            triggerHandler(onClose);
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal size="xl" isOpen={show} toggle={handleCancelClick} onOpen={handleOpen}>
            <ModalHeader>
                <Trans>Link document</Trans>
            </ModalHeader>
            <ModalBody>
                <div className="form-group">
                    <UnitSelector
                        onChange={setLinkedResidentialUnitIds}
                        projectId={projectId}
                        selectedResidentialUnitIds={linkedResidentialUnitIds}
                    />
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="tertiary" onClick={handleCancelClick} disabled={saving}>
                    <Trans>Cancel</Trans>
                </Button>
                <Button color="primary" onClick={handleAccept} loading={saving}>
                    <Trans>Link</Trans>
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default DocumentLinkDialog;
